/* eslint-disable no-console */
import { initializeOpenAIWidget, destroyAllOpenAIWidgets } from '../openai/openaiWidget';
import { initializeAWSWidget, destroyAWSWidget } from '../aws/awsWidget';
import { subscribeLiveAgentChannel, unsubscribeLiveAgentChannel } from './liveAgentChannel';

const AGENT_NAME = 'Live Agent';
let widgetInitialized = false;
let boundToggleHandler = null;

async function toggleWidget() {
  const container = document.getElementById('chatkit-widget-container');
  if (!container) return;

  const chatWindow = container.querySelector('#chatkit-window');
  const toggleButton = container.querySelector('#chatkit-toggle');
  if (!chatWindow || !toggleButton) return;

  const isOpen = chatWindow.style.display === 'block';

  if (!isOpen) {
    if (!widgetInitialized) {
      await initializeOpenAIWidget(container);
      subscribeLiveAgentChannel(container);
      widgetInitialized = true;
    }
    chatWindow.style.display = 'block';
    toggleButton.style.display = 'none';
  } else {
    chatWindow.style.display = 'none';
    toggleButton.style.display = 'block';
  }
}

export function setupToggleWidget() {
  const container = document.getElementById('chatkit-widget-container');
  if (!container) return;

  const toggleButton = container.querySelector('#chatkit-toggle');
  const closeButton = container.querySelector('#chatkit-close');

  boundToggleHandler = () => toggleWidget();

  if (toggleButton) {
    toggleButton.addEventListener('click', boundToggleHandler);
  }

  if (closeButton) {
    closeButton.addEventListener('click', boundToggleHandler);
  }
}

export function cleanupToggleWidget() {
  if (!boundToggleHandler) return;

  const container = document.getElementById('chatkit-widget-container');
  if (container) {
    const toggleButton = container.querySelector('#chatkit-toggle');
    const closeButton = container.querySelector('#chatkit-close');
    if (toggleButton) toggleButton.removeEventListener('click', boundToggleHandler);
    if (closeButton) closeButton.removeEventListener('click', boundToggleHandler);
  }
  boundToggleHandler = null;
}

export function destroyAllWidgets() {
  unsubscribeLiveAgentChannel();
  destroyAllOpenAIWidgets();
  const awsChatkit = document.querySelector('#chatkit-widget-container aws-chatkit');
  destroyAWSWidget(awsChatkit);
  widgetInitialized = false;
}

function switchToLiveAgent(liveAgentData) {
  destroyAllWidgets();

  const container = document.getElementById('chatkit-widget-container');
  if (!container) return;

  const openaiChatkit = container.querySelector('openai-chatkit');
  const awsChatkit = container.querySelector('aws-chatkit');
  openaiChatkit.classList.add('d-none');
  awsChatkit.classList.remove('d-none');
  container.querySelector('.agent-name').textContent = AGENT_NAME;

  initializeAWSWidget(awsChatkit, liveAgentData);
}

let pendingLiveAgentData = null;

document.addEventListener('chatkit.live-agent-request', (event) => {
  pendingLiveAgentData = event.detail;
});

document.addEventListener('chatkit.response.end', () => {
  if (!pendingLiveAgentData) return;

  const data = pendingLiveAgentData;
  pendingLiveAgentData = null;
  setTimeout(() => switchToLiveAgent(data), 3000);
});
